import React from "react";
import { Link } from "react-router-dom";
import { ExploreApps } from "../../shared-features/explore-apps/ExploreApps";
import { Hero } from "../../shared-features/hero/Hero";
import { EraIcon } from "../../../styles/Icon.js";
import { getPhrase } from "../../../utils/Languages.js";
/*
 * EmptyState's title is a paragraph, so this page uses the shared hero
 * for the h1. Mounted only from the flag-on catch-all route.
 */
export default function NotFound() {
    return (React.createElement(React.Fragment, null,
        React.createElement(Hero, { compact: true, icon: React.createElement(EraIcon, { faName: "location-dot", style: { margin: "var(--era-space-0)" } }), title: getPhrase("notFoundTitle"), text: getPhrase("notFoundText"), actions: React.createElement(React.Fragment, null,
                React.createElement(Link, { className: "redesign-home-action redesign-home-action-primary", to: "/" }, getPhrase("notFoundHome")),
                React.createElement(Link, { className: "redesign-home-action redesign-home-action-secondary", to: "/unified-search" }, getPhrase("notFoundSearchInfrastructure"))) }),
        React.createElement(ExploreApps, null)));
}
